import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResearchArticle() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/research/${id}`)
      .then(res => setArticle(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="research-article-page">
      <Navbar />
      <div className="pt-24 pb-12 px-6">
        <div className="max-w-4xl mx-auto">
          <Link to="/research" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8 transition-colors" data-testid="back-to-research">
            <ArrowLeft className="w-4 h-4" /> Back to Research Board
          </Link>

          {loading ? (
            <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div></div>
          ) : !article ? (
            <div className="text-center py-12 bg-white rounded border border-slate-200">
              <p className="text-slate-600">Article not found.</p>
            </div>
          ) : (
            <article className="bg-white p-8 rounded-xl border border-slate-200">
              <h1 className="text-4xl font-serif font-bold tracking-tight text-slate-900 mb-3" data-testid="article-title">{article.title}</h1>
              <div className="flex items-center gap-3 text-sm text-slate-500 mb-8 pb-6 border-b border-slate-100">
                <span>By {article.author}</span>
                <span>|</span>
                <span>{new Date(article.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
              </div>
              <div className="prose prose-slate max-w-none" data-testid="article-content" dangerouslySetInnerHTML={{ __html: article.content }} />
            </article>
          )}
        </div>
      </div>
    </div>
  );
}
